export default __webpack_public_path__ + "static/media/newBank.33cb6878.svg";